import React from 'react';
import LayoutInput from 'components/forms/layoutInput';
import Col from 'components/Col';
import ValidationGroup from 'helpers/validation';
import PropTypes from 'prop-types';
import {inRange} from './helpers';
import {injectIntl, intlShape} from 'react-intl';
import {calculationUnits} from 'helpers/constants';
import {metersToFeets} from 'helpers/dataHelpers';

class Rectangle extends React.Component {
  static propTypes = {
    group: PropTypes.instanceOf(ValidationGroup).isRequired,
    intl: intlShape,
    unit: PropTypes.string,
  };

  static initialState = {
    length: undefined,
    width: undefined,
  };

  state = Rectangle.initialState;

  update = ({key, value}) => {
    this.setState({[key]: parseFloat(value)});
  };

  volume = averageDepth => {
    let {length, width, unit} = this.state;

    if (unit === calculationUnits.meter) {
      length = metersToFeets(length);
      width = metersToFeets(width);
    }

    return length * width * averageDepth * 7.5;
  };

  reset = () => {
    this.setState(Rectangle.initialState);
  };

  render() {
    const {formatMessage} = this.props.intl;
    const measureUnit = this.props.unit === calculationUnits.meter ? formatMessage({id: 'general.unit.meter'}) : formatMessage({id: 'general.unit.feet'});

    return [
      <Col md={4} key='length-col'>
        <LayoutInput type='number'
                     dataKey='length'
                     step='0.01'
                     autoFocus
                     toolTip={formatMessage({id: 'quick-calcs.pool-volume.length.tooltip'}, {unit: measureUnit.toLowerCase()})}
                     label={formatMessage({id: 'quick-calcs.pool-volume.length'})}
                     dataChanged={this.update}
                     group={this.props.group}
                     validate={inRange}
                     value={this.state.length}
                     required />
      </Col>,
      <Col md={4} key='width-col'>
        <LayoutInput type='number'
                     dataKey='width'
                     step='0.01'
                     toolTip={formatMessage({id: 'quick-calcs.pool-volume.width.tooltip'}, {unit: measureUnit.toLowerCase()})}
                     label={formatMessage({id: 'quick-calcs.pool-volume.width'})}
                     group={this.props.group}
                     dataChanged={this.update}
                     validate={inRange}
                     value={this.state.width}
                     required />
      </Col>,
    ];
  }
}

export default injectIntl(Rectangle, {withRef: true});
